import { listRecommendByProjectId } from '@/api/home';
import { isNil, isNumber, isString, cloneDeep, values } from 'lodash';
// import { getDefaultKanbanConfig, getProjectKanbanConfig } from '@/api/home';
// import { tryToNumber } from '@zk/framework-vue';
export function calcGridColWidth(positionParams) {
  const { margin, containerWidth, cols } = positionParams;
  return (
    (containerWidth - (margin[0] * (cols + 1))) / cols
  );
}
export const checkPermissionList = ['BugWidget', 'CumulativeFlowDiagram', 'BurnupWidget', 'BurndownWidget', 'ChartWidget', 'StatisticsWidget'];
export function getWidgetConfig(widgetComponent) {
  // todo 的结构不同，需要特殊处理；
  if (widgetComponent.name === 'TodoListWidget') {
    const { widget } = widgetComponent.components.TodoList;
    return typeof widget === 'function' ? Reflect.apply(widget, widget, [widgetComponent]) : widget;
  }

  const { widget } = widgetComponent;
  return typeof widget === 'function' ? Reflect.apply(widget, widget, [widgetComponent]) : widget;
}

export const isOverlap = (item, item2) => {
  // item 在 item2 的左边
  if (item.x + item.w <= item2.x) {
    return false;
  }
  // item 在 item2 的右边
  if (item.x >= item2.x + item2.w) {
    return false;
  }
  // item 在 item2 的上面
  if (item.y + item.h <= item2.y) {
    return false;
  }
  // item 在 item2 的下面
  if (item.y >= item2.y + item2.h) {
    return false;
  }
  // 重叠
  return true;
};

/**
 * @desc 通过项目 id 获取最近操作的迭代已经迭代列表
 * @param {number|string} projectId
 * @return {Promise<{recentSprint: Object, sprintList: Array<Object>}>}
 * */
export function useProjectGetLatelyHandleSprint(projectId) {
  if (!isString(projectId) && !isNumber(projectId)) {
    return Promise.reject('projectId 有误');
  }
  return new Promise((resolve, reject) => {
    listRecommendByProjectId({ projectId, type: 'recent' }).then((sprintList) => {
      if (isNil(sprintList)) {
        sprintList = [];
      }
      const recentSprint = sprintList.find(item => item.recentVisit) || sprintList[0];
      resolve({
        recentSprint,
        sprintList: sprintList.map(item => {
          if (isNil(item.value)) {
            item.value = item.id;
          }
          return item;
        })
      });
    }).catch((e) => {
      reject(e);
    });
  });
}

/**
 * 对比两个对象的是否相同，  (排除keys中的内容)
 * @param {d} o1
 * @param {*} o2
 * @param {*} keys
 * @returns
 */
export function isEqualExclude(o1, o2, keys){
  if (!o1 || !o2) {
    return false;
  }
  if (typeof o1 === 'string') {
    o1 = JSON.parse(o1);
  }
  if (typeof o2 === 'string') {
    o2 = JSON.parse(o2);
  }
  const clone1 = cloneDeep(o1);
  const clone2 = cloneDeep(o2);
  keys.forEach((key)=>{
    Reflect.deleteProperty(clone1, key);
    Reflect.deleteProperty(clone2, key);
  });
  return JSON.stringify(clone1) === JSON.stringify(clone2);
}


// export async function getKanbanConfig(projectList, _projectId, defaultConfigs){
//   let config = {};
//   if (_projectId) {
//     config = await getProjectKanbanConfig(_projectId);
//   } else {
//     config = defaultConfigs ? defaultConfigs : await getDefaultKanbanConfig();
//   }

//   const projectId = config.sprintTrackFilterVO?.projectId;
//   const projectName = projectList.find(i => i.id === projectId)?.pname;
//   const habitKey = `userHabit-${projectId}`;
//   const filterKey = `filter-${projectId}`;
//   const filterValueKey = `filterValue-${projectId}`;

//   let workFlowId = config.issueTypeWorkflowGroupVOList?.find(i => {
//     return i.issueTypes.some(issueType => {
//       return config.sprintTrackFilterVO?.issueTypeIds.includes(issueType.id);
//     });
//   })?.id;
//   if (!workFlowId && config.issueTypeWorkflowGroupVOList) {
//     workFlowId = config.issueTypeWorkflowGroupVOList[0]?.id;
//   }
//   const settings = {
//     projectId,
//     projectName,
//     [habitKey]: {
//       kanbanIssueType: config.sprintTrackFilterVO?.issueTypeIds,
//       workFlowId: workFlowId,
//       subTaskFilterTurnOff: config.subTaskFilterTurnOff
//     }
//   };
//   Object.keys(config.customerHabitMap).forEach((key) => {
//     settings[habitKey][key] = config.customerHabitMap[key].linkIdList;
//   });

//   if (config.addedFilterFieldList) {
//     settings[filterKey] = config.addedFilterFieldList.map(i => {
//       return {
//         id: i.customFieldId,
//         code: i.customFieldCode,
//         controlCode: i.controlCode,
//         customFieldName: i.customFieldName
//       };
//     });
//   }
//   if (config.selectOptionMap) {
//     settings[filterValueKey] = Object.keys(config.selectOptionMap).map(key => {
//       return {
//         id: key,
//         value: config.selectOptionMap[key].map(i => tryToNumber(i)).map(v => v === 'null' ? null : v)
//       };
//     });
//   }

//   return settings;
// }

/**
 * 获取所有工作台组件（自动扫描一级目录）
 * @returns 所有GridDashboard/Widget目录下的组件配置
 */
export const getWidgets = async () => {
  const widgets = await require.context('@/components/GridDashboard/Widget', false, /\.vue$/, 'lazy-once');
  const map = widgets.keys().reduce((result, key) => ({
    ...result,
    [key]: widgets(key)
  }), {});
  return (await Promise.all(values(map))).map(com => com.default || com);
};
